import { connect } from 'react-redux';
import { resetInstallmentsPlan, selectInstalmentsPlan } from '@/actions/purchase';
import Installments from './Installments';

const mapStateToProps = ({ purchase }) => {
  const purchaseJs = purchase.toJS();

  const {
    qualifiesForMonthlyInstallments,
    paymentPlans,
    monthlySelectedPlan,
    selectedInstallmentsPlan,
  } = purchaseJs;

  /**
   * The backend's `qualifies_for_monthly_installments` is `payment_plans.present?` over a hash that
   * always has a `visa_mc` and an `amex` key, so it is `true` even when the tenant's fee table is
   * empty and no term is actually offered. Deciding on the terms themselves keeps
   * `Math.max()` from being spread over zero keys, which returns -Infinity and leaks into the
   * "pay in up to N months" copy. It also covers the render before `getPurchase` resolves, when
   * neither field is in the store yet.
   */
  const visaMcPlan = paymentPlans?.visaMc || {};
  const offeredMonths = Object.keys(visaMcPlan).map(Number);
  const offersInstallments = Boolean(qualifiesForMonthlyInstallments) && offeredMonths.length > 0;

  let maxInstallmentsPlan = {};

  if (offersInstallments) {
    const maxMonths = Math.max(...offeredMonths);
    maxInstallmentsPlan = { ...visaMcPlan[maxMonths], months: maxMonths };
  }

  return {
    qualifiesForMonthlyInstallments: offersInstallments,
    paymentPlans: paymentPlans || {},
    maxInstallmentsPlan,
    monthlySelectedPlan: monthlySelectedPlan || 1,
    selectedInstallmentsPlan,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetInstallmentsPlan: () => {
      dispatch(resetInstallmentsPlan());
      dispatch(selectInstalmentsPlan('singlePayment'));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Installments);
